/**
 * site-scripts.js
 *
 * All general site scripts
 */

//import Swiper from 'swiper/bundle';
import { groupEventListener } from "./utils";

const $ = jQuery;

// scroll header
window.addEventListener("scroll", function () {
  var header = document.querySelector("header");
  if (window.scrollY >= 20) {
    header.classList.add("c-header--scrolled");
  } else {
    header.classList.remove("c-header--scrolled");
  }
});

/* =========================
   NAV OPEN/CLOSE (moved to DOMContentLoaded so it works in bundle)
   ========================= */
window.addEventListener("DOMContentLoaded", function () {
  const hamburger = document.querySelector(".js-hamburger");
  const nav = document.querySelector(".c-nav");
  const close = document.querySelector(".c-nav-close");

  if (!nav) return;

  // OPEN
  if (hamburger) {
    hamburger.addEventListener("click", function () {
      nav.classList.add("c-nav--open");
    });
  }

  // Shared close sequence (matches your existing X timing)
  function closeNav() {
    if (!nav.classList.contains("c-nav--open")) return;
    nav.classList.add("c-nav--close");
    setTimeout(function () {
      nav.classList.remove("c-nav--open");
      setTimeout(function () {
        nav.classList.remove("c-nav--close");
      }, 500);
    }, 300);
  }

  // X button
  if (close) {
    close.addEventListener("click", function (e) {
      e.preventDefault();
      closeNav();
    });
  }

  // Click OFF (backdrop) – stop clicks inside the panel
  const navInner = nav.querySelector(
    ".c-nav__panel, .c-nav__inner, .c-nav__content, .c-nav-inner, [data-nav-panel]",
  );
  if (navInner) {
    navInner.addEventListener(
      "click",
      function (e) {
        e.stopPropagation();
      },
      { passive: true },
    );
  }
  nav.addEventListener("click", function (e) {
    if (e.target === nav) closeNav();
  });

  // ESC to close
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeNav();
  });
});

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function (event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        setTimeout(function () {
          $("html, body").animate(
            {
              scrollTop: target.offset().top - 150,
            },
            1000,
            function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            },
          );
        }, anchorDelay);
      }
    }
  });

// smooth scroll on visit subnav - visit page
$(document).on("click", 'a[href^="#"]', function (event) {
  event.preventDefault();

  $("html, body").animate(
    {
      scrollTop: $($.attr(this, "href")).offset().top - 275,
    },
    500,
  );
});

//
jQuery("#animated-thumbnails-gallery")
  .justifiedGallery({
    captions: false,
    lastRow: "hide",
    rowHeight: 180,
    margins: 5,
  })
  .on("jg.complete", function () {
    window.lightGallery(
      document.getElementById("animated-thumbnails-gallery"),
      {
        autoplayFirstVideo: false,
        pager: false,
        galleryId: "nature",
        plugins: [lgZoom, lgThumbnail],
        mobileSettings: {
          controls: false,
          showCloseIcon: false,
          download: false,
          rotate: false,
        },
      },
    );
  });

// Menu Mobile Script
function getWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}

/* Modal for GM/Executive Chef */
$(".js-popup-trigger").each(function () {
  $(this).on("click", function () {
    $(this).next(".c-popup-modal").fadeIn();
  });
});

$(".js-popup-close").each(function () {
  $(this).on("click", function () {
    $(".c-popup-modal").fadeOut(600);
  });
});

/* Announcement Bar Modal */
$(".js-modal-trigger-announcement").each(function () {
  $(this).on("click", function (e) {
    e.preventDefault();
    $(this).next(".c-modal-announcement").fadeIn();
  });
});

$(".js-modal-close-announcement").each(function () {
  $(this).on("click", function () {
    $(".c-modal-announcement").fadeOut(600);
  });
});

/**
 * Gold Button Arrow Animation
 */
document.querySelectorAll(".button--gold").forEach(
  (b) =>
    (b.onmouseenter = (e) => {
      e.target.classList.add("extend");
      e.target.classList.remove("shrink");
    }),
);

document.querySelectorAll(".button--gold").forEach(
  (b) =>
    (b.onmouseleave = (e) => {
      e.target.classList.remove("extend");
      e.target.classList.add("shrink");
    }),
);

document.getElementById("selectlocation").onclick = function () {
  var className = " " + selectlocation.className + " ";
  this.className = ~className.indexOf(" active ")
    ? className.replace(" active ", " ")
    : this.className + " active";
};

$(".locations-list").click(function () {
  $(".locations-nav").slideToggle();
})(function ($) {
  // Header Events

  const body = document.body;
  $(document).on("ready", function () {
    // Replace any href="#" links with href="javascript:void(0)"
    if (document.body.contains(document.querySelector('[href="#"]'))) {
      const emptyHrefs = Array.prototype.slice.call(
        document.querySelectorAll('[href="#"]'),
      );
      emptyHrefs.forEach((link) => {
        link.href = "javascript:void(0)";
      });
    }

    // Add .js-subnav-toggle class to any mobile nav items with children
    if (
      document.body.contains(document.querySelector(".menu-item-has-children"))
    ) {
      const topLevelItems = Array.prototype.slice.call(
        document.querySelectorAll(".menu-item-has-children"),
      );
      topLevelItems.forEach((item) => {
        item.classList.add("js-subnav-toggle");
      });
    }

    // If .sub-menu exists
    if (document.body.contains(document.querySelector(".sub-menu"))) {
      groupEventListener(
        "click",
        document.querySelectorAll(".js-subnav-toggle"),
        toggleSubMenu,
      );
    }

    if (document.querySelector(".js-play")) {
      document.querySelector(".js-play").addEventListener("click", toggleVideo);
      document
        .querySelector(".btn--play")
        .addEventListener("click", togglePlay);
    }

    if (
      document.body.contains(document.querySelector(".js-modal")) ||
      document.body.classList.contains("search")
    ) {
      groupEventListener(
        "click",
        document.querySelectorAll(".js-modal"),
        toggleModal,
      );
      groupEventListener(
        "click",
        document.querySelectorAll(".js-close-modal"),
        closeModal,
      );
    }
  });

  if (document.body.contains(document.querySelector(".hamburger"))) {
    document
      .querySelector(".hamburger")
      .addEventListener("click", openMobileNav);
    document
      .querySelector(".header--mobile .btn--close")
      .addEventListener("click", closeMobileNav);
    document.querySelectorAll(".aria-expanded-toggle").forEach(function (item) {
      item.addEventListener("click", toggleAriaExpanded);
    });
  } else {
    document.querySelectorAll(".aria-expanded-toggle").forEach(function (item) {
      item.addEventListener("mouseover", toggleAriaExpanded);
    });
    document.querySelectorAll(".aria-expanded-toggle").forEach(function (item) {
      item.addEventListener("mouseout", toggleAriaExpanded);
    });
  }

  // Expand Module
  groupEventListener(
    "click",
    document.querySelectorAll(".js-expand"),
    expandModule,
  );
  groupEventListener(
    "click",
    document.querySelectorAll(".js-toggle-list"),
    toggleList,
  );

  function openMobileNav() {
    document.querySelector(".header--mobile").classList.add("-is-open");
    document.querySelector(".btn--close").focus();
    document.querySelector("body").classList.add("-hide-page-overflow");
  }

  function closeMobileNav() {
    document.querySelector(".header--mobile").classList.remove("-is-open");
    document.querySelector("body").classList.remove("-hide-page-overflow");
  }

  function toggleSubMenu() {
    this.classList.toggle("active");
  }
})(jQuery);
